module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_8.abfac3a0.pdf";